const Lang = {
  formValidation: {
    required: () => 'This field is required',
    notZero: () => 'This field is required',
    checkboxRequired: () => 'This field is required',
    minLength: (field, number) => `${field} needs to be at least ${number.min} characters`,
    maxLength: (field, number) => `${field} needs to be at max ${number.max} characters`,
    minValue: () => 'This field cannot be in the past',
    email: () => 'Your email does not appear to be valid (make sure it is all in lowercase)',
    passwordMatch: () => 'Passwords do not match',
    sameAsPassword: () => 'Password fields do not match',
    numeric: () => 'This field needs to be a numeric value',
    fullName: () => 'This field needs to have at least 2 words',
    url: () => 'This field requires a valid URL',
    maxUploadedFileSize: () => 'File exceeds the maximum file size.',
    allowedFileMimeTypes: () => 'The file type is not allowed.',
  },
};

export default Lang;
